import { useAppSelector } from "../../../../../hook/useAppSelector";

import Modal from "../Modal/Modal";
import ShellModal from "../Modal/ShellModal";
import CommandLineInterface from "../Modal/CommandLineInterface";

import { ModalConfig } from "../../../../../util/health-monitor/modal-config";

const ModalWrapper: React.FC = () => {
  const modalType = useAppSelector((state) => state.modalSlice.modalType);
  const isShellModalVisible = useAppSelector(
    (state) => state.modalSlice.isShellModalVisible
  );
  const isCommandLineInterfaceModalOpen = useAppSelector(
    (state) => state.modalSlice.isCommandLineInterfaceModalOpen
  );
  const isLoadingSomeOfDeviceDetails = useAppSelector(
    (state) => state.deviceDetails.isLoadingSomeOfDeviceDetails
  );

  return (
    <>
      {modalType && !isShellModalVisible && (
        <Modal
          modalMessage={ModalConfig[modalType].message}
          onConfirm={ModalConfig[modalType].onConfirm}
          onCancel={ModalConfig[modalType].onCancel}
        ></Modal>
      )}

      {isShellModalVisible && !isLoadingSomeOfDeviceDetails && (
        <ShellModal></ShellModal>
      )}

      {isCommandLineInterfaceModalOpen && (
        <CommandLineInterface></CommandLineInterface>
      )}
    </>
  );
};

export default ModalWrapper;
